import React from 'react';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { RightColumnProvider } from 'Context/RightColumnContext';
import ScenarioQuestionPicker
  from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedWrapperTemplate/ScenarioQuestionPicker';
import { RoadmapDeliverablePortfolioUpdatesContent } from './content';

const metaOverrideSet = buildFacetDesignOverride();

export const RoadmapDeliverablePortfolioUpdatesLayout = () => {
  const { resource } = useMetaLayoutContext();

  return (
    <RightColumnProvider>
      <MetaResourceRenderer
        resource={resource}
        layout={RoadmapDeliverablePortfolioUpdatesContent}
        metaOverrideSet={metaOverrideSet}
      />
      <ScenarioQuestionPicker />
    </RightColumnProvider>
  );
};
